const getClassName = (className: string, disabled?: boolean): string => {
    if (!disabled) {
      return className;
    }
    return `${className} ${className}-disabled`
}

export default getClassName;
